const careersJobFilter = [
    {
        selector: '[data-react="jobFilter"]',
        path: { filename: 'App' },
    },
];

export { careersJobFilter };
